import match from "@/api/modules/match";
import competition from "@/api/modules/competition";
import prematch from "@/api/modules/prematch";

export default {
  match,
  competition,
  prematch
}
